import api from '../../../services/Api';
import { IAuditoriaValorRedondoResultado } from '../interfaces/IAuditoriaValorRedondo';

export const AuditoriaValorRedondoService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaValorRedondoResultado> => {
    const response = await api.get<IAuditoriaValorRedondoResultado>(
      'auditoria-valor-redondo/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
